// extracted by mini-css-extract-plugin
module.exports = {"actions":"TalentInviteLinksModal_actions__HensM","urlCell":"TalentInviteLinksModal_urlCell__1-Ih_"};